import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();

  const navItems = [
    { to: '/', label: 'HOME' },
    { to: '/menu', label: 'MENU' },
    { to: '/about', label: 'ABOUT' },
    // { to: '/contact', label: 'CONTACT' },
  ];

  return (
    <nav className="nav">
      {navItems.map((item, index) => (
        <Link 
          key={index} 
          to={item.to} 
          className={`nav-link ${location.pathname === item.to ? 'active' : ''}`}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

export default Navigation; 